export const JOB_STATUSES = [
    { key: "draft", label: "Draft", tone: "neutral" },
    { key: "planned", label: "Planned", tone: "neutral" },
    { key: "released", label: "Released", tone: "ready" },
    { key: "in_progress", label: "In progress", tone: "active" },
    { key: "on_hold", label: "On hold", tone: "hold" },
    { key: "ready_for_delivery", label: "Ready for delivery", tone: "ready" },
    { key: "completed", label: "Completed", tone: "complete" },
    { key: "cancelled", label: "Cancelled", tone: "risk" },
];
export const OPERATION_STATUSES = [
    { key: "not_ready", label: "Not ready", tone: "neutral" },
    { key: "ready", label: "Ready", tone: "ready" },
    { key: "active", label: "Active", tone: "active" },
    { key: "paused", label: "Paused", tone: "hold" },
    { key: "blocked", label: "Blocked", tone: "risk" },
    { key: "completed", label: "Completed", tone: "complete" },
];
export const TASK_STATUSES = [
    { key: "open", label: "Open", tone: "ready" },
    { key: "overdue", label: "Overdue", tone: "risk" },
    { key: "completed", label: "Completed", tone: "complete" },
];
export const CUSTOMER_STATUSES = [
    { key: "lead", label: "Lead", tone: "neutral" },
    { key: "active", label: "Active", tone: "ready" },
    { key: "archived", label: "Archived", tone: "neutral" },
];
export const TASK_PRIORITIES = [
    { key: "low", label: "Low", tone: "neutral" },
    { key: "medium", label: "Medium", tone: "active" },
    { key: "high", label: "High", tone: "risk" },
];
export const ACTIVITY_KINDS = [
    { key: "call", label: "Call", tone: "active" },
    { key: "meeting", label: "Meeting", tone: "ready" },
    { key: "note", label: "Note", tone: "neutral" },
    { key: "email", label: "Email", tone: "active" },
    { key: "site_visit", label: "Site visit", tone: "ready" },
    { key: "other", label: "Other", tone: "neutral" },
];
export const ADDRESS_KINDS = ["billing", "shipping", "site", "other"];
export const QUOTE_STATUSES = [
    { key: "draft", label: "Draft", tone: "neutral" },
    { key: "sent", label: "Sent", tone: "active" },
    { key: "accepted", label: "Accepted", tone: "complete" },
    { key: "declined", label: "Declined", tone: "risk" },
    { key: "expired", label: "Expired", tone: "risk" },
];
export const RFQ_STATUSES = [
    { key: "open", label: "Open", tone: "ready" },
    { key: "quoted", label: "Quoted", tone: "neutral" },
    { key: "closed", label: "Closed", tone: "neutral" },
];
export const SALES_ORDER_STATUSES = [
    { key: "open", label: "Open", tone: "ready" },
    { key: "delivered", label: "Delivered", tone: "complete" },
    { key: "cancelled", label: "Cancelled", tone: "risk" },
];
export const PRODUCT_KINDS = [
    { key: "equipment", label: "Equipment", tone: "neutral" },
    { key: "fabricated", label: "Fabricated item", tone: "neutral" },
    { key: "component", label: "Component", tone: "neutral" },
    { key: "service", label: "Service", tone: "neutral" },
];
export const ESTIMATE_KINDS = [
    { key: "material", label: "Material", tone: "neutral" },
    { key: "labor", label: "Labour", tone: "neutral" },
    { key: "work_center", label: "Work-centre time", tone: "neutral" },
    { key: "outsourced", label: "Outsourced process", tone: "neutral" },
    { key: "fixed", label: "Fixed / other", tone: "neutral" },
];
export const PRODUCTION_KINDS = [
    { key: "good", label: "Good", tone: "complete" },
    { key: "scrap", label: "Scrap", tone: "risk" },
    { key: "rework", label: "Rework", tone: "hold" },
];
export const REASON_KINDS = ["scrap", "rework"];
export const PURCHASE_ORDER_STATUSES = [
    { key: "draft", label: "Draft", tone: "neutral" },
    { key: "issued", label: "Issued", tone: "active" },
    { key: "partially_received", label: "Partially received", tone: "hold" },
    { key: "received", label: "Received", tone: "complete" },
    { key: "cancelled", label: "Cancelled", tone: "risk" },
];
export const INVOICE_STATUSES = [
    { key: "draft", label: "Draft", tone: "neutral" },
    { key: "issued", label: "Issued", tone: "active" },
    { key: "partially_paid", label: "Partially paid", tone: "hold" },
    { key: "paid", label: "Paid", tone: "complete" },
    { key: "overdue", label: "Overdue", tone: "risk" },
    { key: "void", label: "Void", tone: "risk" },
];
export const CASH_DIRECTIONS = ["in", "out"];
export const RFQ_SOURCES = [
    "phone",
    "walk_in",
    "email",
    "referral",
    "website",
    "other",
];
const lookup = (list) => {
    const map = new Map(list.map((s) => [s.key, s]));
    return (key) => map.get(key) ?? { key, label: key, tone: "neutral" };
};
export const jobStatus = lookup(JOB_STATUSES);
export const operationStatus = lookup(OPERATION_STATUSES);
export const taskStatus = lookup(TASK_STATUSES);
export const customerStatus = lookup(CUSTOMER_STATUSES);
export const taskPriority = lookup(TASK_PRIORITIES);
export const activityKind = lookup(ACTIVITY_KINDS);
export const quoteStatus = lookup(QUOTE_STATUSES);
export const rfqStatus = lookup(RFQ_STATUSES);
export const salesOrderStatus = lookup(SALES_ORDER_STATUSES);
export const productKind = lookup(PRODUCT_KINDS);
export const estimateKind = lookup(ESTIMATE_KINDS);
export const productionKind = lookup(PRODUCTION_KINDS);
export const purchaseOrderStatus = lookup(PURCHASE_ORDER_STATUSES);
export const invoiceStatus = lookup(INVOICE_STATUSES);
//# sourceMappingURL=status.js.map